import { Icon, Typography, Checkbox, Menu, CircularProgress } from "@ann/web-components";
import { ItemWrapper, ItemLeft, MenuIconWrapper } from "./Item.styled";
import { useState, useEffect, useRef } from "react";
import { ModalBase } from "../../../../components/Modal";

const DriveDocumentItem = ({ uuid, name, selectMode, onSelect, selectedItems, removeAccessToDocument, removeAccessLoading, setShowSlideoutDocumentDetail, setSelectedDocument }) => {
    const [showMenu, setShowMenu] = useState(false);
    const [showRemoveAccessModal, setShowRemoveAccessModal] = useState(false);
    const [removingAccess, setRemovingAccess] = useState(false);
    const menuRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setShowMenu(false);
            }
        };
        if (showMenu) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [showMenu]);

    const handleMenuClick = () => {
        setShowMenu(!showMenu);
    }
    const handleRemoveAccess = () => {
        setRemovingAccess(true);
        setShowMenu(false);
        setShowRemoveAccessModal(false);
        removeAccessToDocument(uuid);
    };
    const handleRemoveAccessClick = () => {
        setShowRemoveAccessModal(true);
    };

    const handleViewDetails = () => {
        setSelectedDocument({
            uuid,
            title: name
        });
        setShowSlideoutDocumentDetail(true);
        setShowMenu(false);
    };


    useEffect(() => {
        if (removeAccessLoading & selectedItems.includes(uuid)) {
            setRemovingAccess(true);
        }
        else {
            setRemovingAccess(false);
        }
    }, [removeAccessLoading]);

    return (
        <>
            <ItemWrapper disabled={removingAccess}>
                <ItemLeft>
                    {selectMode && (
                        <Checkbox
                            onChange={() => onSelect(uuid)}
                            size="medium"
                            checked={selectedItems.includes(uuid)}
                        />
                    )}
                    <Icon name="description" size="medium" />
                    <Typography category="subtitle" size="small" weight="bold" color="subtitle">
                        {name}
                    </Typography>
                </ItemLeft>
                <MenuIconWrapper onClick={handleMenuClick}>
                    {removingAccess ? <CircularProgress /> : <Icon name="dotsMenu" />}
                </MenuIconWrapper>
                {showMenu && (<Menu className="add-menu" width="260px">
                    <div ref={menuRef}>
                    <Menu.Item id="Remove-access" title='Remove access' onClick={handleRemoveAccessClick} />
                    <Menu.Item id="View-details" title='View details' onClick={handleViewDetails} />                        
                    </div>
                </Menu>)}
            </ItemWrapper>
            {showRemoveAccessModal && (
                <ModalBase
                    isOpen={showRemoveAccessModal}
                    onClose={() => setShowRemoveAccessModal(false)}
                    onClick={handleRemoveAccess}
                    title={`Are you sure you want to remove access?`}
                    description={"Your agent won’t be able to use it for responses until you reconnect it."}
                    buttonTitle="Remove access"
                    modalWidth="571px" />
            )}
        </>
    )
}

export default DriveDocumentItem;